import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  WORK_ORDER_VIEWS, loadWorkOrderView, saveWorkOrderView, subscribeWorkOrderView,
} from "../features/workorders/workOrderViews";
import type { WorkOrderView } from "../features/workorders/workOrderViews";

// 左側「製單」底下的二級選單(業主 2026-11-02):全部 / 已結案 / 未結案。
// 只在製單那幾頁展開,樣子與報價單的 QuoteSubNav 一樣。

export function WorkOrderSubNav({ onPicked }: { onPicked?: () => void }) {
  const navigate = useNavigate();
  const [current, setCurrent] = useState<WorkOrderView>(loadWorkOrderView);

  useEffect(() => subscribeWorkOrderView(setCurrent), []);

  const pick = (view: WorkOrderView) => {
    saveWorkOrderView(view);
    navigate("/workorders");
    onPicked?.();
  };

  return (
    <ul aria-label="製單分類" className="m-0 mt-0.5 flex list-none flex-col gap-0.5 p-0 pl-7">
      {WORK_ORDER_VIEWS.map((view) => {
        const active = current === view.key;
        return (
          <li key={view.key}>
            <button
              type="button"
              aria-current={active ? "true" : undefined}
              onClick={() => pick(view.key)}
              className={
                "w-full rounded-[var(--radius)] px-3 py-1 text-left text-sm " +
                (active
                  ? "font-medium text-[var(--accent-hover)]"
                  : "text-[var(--text-3)] hover:bg-[var(--surface-2)] hover:text-[var(--text)]")
              }
            >
              {view.label}
            </button>
          </li>
        );
      })}
    </ul>
  );
}
